import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Mensajes = {
    obtenerMensajes: async () => {
        let url = url_json + "/mensaje"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    // params: buscar, pagina, limite (los vacíos no se mandan)
    listar: async params => {
        let query = new URLSearchParams(Object.entries(params).filter(([clave, valor]) => valor !== undefined && valor !== null && (valor !== '' || clave === 'licenciatura')));
        let url = url_json + "/mensaje/lista?" + query;
        let request = {
            method: 'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnMensaje: async id => {
        let url = url_json + "/mensaje/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    eliminarMensaje: async id => {
        let url = url_json + "/mensaje/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Mensaje eliminado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar el mensaje: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    }
}

export default Mensajes;
